export const PayrollTierSegmentEvents = {
  TIER_PUCHASE_COMPLETED: `payroll-tier-purchase-completed`,
  PAYROLL_TIER_PLANS_BANNER_CLICKED: `payroll-tier-plans-banner-clicked`,
  PAYROLL_TIER_PLANS_MODAL_SHOWN: `payroll-tier-plans-modal-shown`,
};

export default PayrollTierSegmentEvents;
